// extracted by mini-css-extract-plugin
export default {"container":"v_d","sidebarWrapper":"v_dt","title":"v_c0"};